import { FC } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { EmailCampaign } from '../EmailCampaign';
import { RouteConstants } from '@/features/router/RouteConstants';
import { EmailCampaignGateGuard } from '../components/EmailCampaignGateGuard';

export const CampaignsEmailEditFlowV2: FC = () => {
  const history = useHistory();
  const { campaignId } = useParams<{ campaignId: string }>();

  const handleExitToList = () => {
    history.push(RouteConstants.emailCampaigns);
  };

  return (
    <EmailCampaignGateGuard>
      <EmailCampaign mode='edit' campaignId={campaignId} onExitToList={handleExitToList} />
    </EmailCampaignGateGuard>
  );
};
